<template>
  <footer class="footer">
    <div class="container footer-content">
      <!-- 左侧：Logo 和 简介 -->
      <div class="footer-left">
        <!-- 使用一个占位 Logo 图片 -->
        <img src="@/assets/images/login/logo_nav.png" alt="金试商城 Logo" class="footer-logo" />
        <p class="company-desc">
          金试商城 (JINSHI PRO) 致力于为未来实验室提供高品质的化学试剂、生命科学耗材及高端仪器设备。我们以科技赋能科研，构建一站式科研采购平台，助力每一项伟大的发现。
        </p>
      </div>

      <!-- 右侧：联系方式 -->
      <div class="footer-right">
        <h4 class="footer-title">联系我们</h4>

        <div class="contact-list">
          <div class="contact-item">
            <i class="fas fa-phone-alt"></i>
            <div class="item-text">
              <span class="label">服务热线</span>
              <span class="value">021-60889184</span>
            </div>
          </div>
          <div class="contact-item">
            <i class="fas fa-envelope"></i>
            <div class="item-text">
              <span class="label">企业邮箱</span>
              <span class="value">jinshish2025@163.com</span>
            </div>
          </div>
          <div class="contact-item">
            <i class="fas fa-map-marker-alt"></i>
            <div class="item-text">
              <span class="label">公司地址</span>
              <span class="value">上海市奉贤区南桥镇环城西路2511号菱光大厦2号楼518室</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container copyright">
      © 2025 上海金试生化科技有限公司 版权所有 | ICP备案号：沪ICP备2025136350号 | <el-popover placement="top" :width="200" trigger="hover"
        popper-class="cert-popover">
        <template #reference>
          <span class="license-text">营业执照三证</span>
        </template>

        <div class="popover-content">
          <el-image src="https://erp-huaxue.oss-cn-shanghai.aliyuncs.com/erp/2026/02/10/698b269e0fce228522ec07c3.png"
            :preview-src-list="['https://erp-huaxue.oss-cn-shanghai.aliyuncs.com/erp/2026/02/10/698b269e0fce228522ec07c3.png', '第二张图地址']" 
            class="popover-img" />
          
        </div>
      </el-popover>
      <!-- <el-popover placement="top" :width="200" trigger="hover"
        popper-class="cert-popover">
        <template #reference>
          <span class="license-text">危险品化学品经营许可证</span>
        </template>

        <div class="popover-content">
          <el-image src="https://erp-1387798296.cos.ap-shanghai.myqcloud.com/licence.jpg"
            :preview-src-list="['https://erp-1387798296.cos.ap-shanghai.myqcloud.com/licence.jpg', '第二张图地址']"
            class="popover-img" />
        </div>
      </el-popover>  --><a href="https://hishuogao.com">江苏硕高网络科技有限公司</a> 技术支持
    </div>
  </footer>
</template>

<script setup>


</script>

<style scoped>
.footer {
  background: #fff;
  margin-top: 0;
  padding: 60px 0 20px;
  border-top: 1px solid #e2e8f0;
}

.footer-content {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 80px;
  /* 增加间距 */
}

/* 左侧区域 */
.footer-left {
  flex: 1;
  max-width: 500px;
}

.footer-logo {
  height: 50px;
  /* Logo 高度 */
  width: auto;
  margin-bottom: 25px;
}

.company-desc {
  color: #64748b;
  font-size: 14px;
  line-height: 1.8;
  text-align: justify;
}

/* 右侧区域 */
.footer-right {
  flex: 1;
  max-width: 400px;
}

.footer-title {
  font-size: 18px;
  /* 稍微调小标题字号 */
  font-weight: 800;
  color: var(--text-main);
  margin-bottom: 25px;
  position: relative;
  display: inline-block;
}

.footer-title::after {
  content: '';
  position: absolute;
  bottom: -10px;
  left: 0;
  width: 30px;
  height: 4px;
  background: var(--tech-blue);
  border-radius: 2px;
}

.contact-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.contact-item {
  cursor: pointer;
  display: flex;
  align-items: center;
}

.contact-item i {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(0, 102, 204, 0.05);
  color: var(--tech-blue);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  margin-right: 15px;
  transition: 0.3s;
}

.contact-item:hover i {
  background: var(--tech-blue);
  color: #fff;
}

.item-text {
  display: flex;
  flex-direction: column;
}

.item-text .label {
  font-size: 12px;
  color: #94a3b8;
  margin-bottom: 2px;
}

.item-text .value {
  font-size: 15px;
  color: #333;
  font-weight: 500;
}

/* 版权信息 */
.copyright {
  text-align: center;
  margin-top: 50px;
  padding-top: 20px;
  border-top: 1px solid #f1f5f9;
  color: #94a3b8;
  font-size: 12px;
}

.copyright a {
  color: inherit;
  text-decoration: none;
}

.copyright a:hover {
  color: #409eff;
  /* Element Plus 主题蓝 */
}

/* 模拟链接样式的文字 */
.license-text {
  cursor: pointer;
  margin: 0 5px;
}

.license-text:hover {
  color: #409eff;
  text-decoration: underline;
}

/* 弹窗内图片容器 */
.popover-content {
  display: flex;
  gap: 10px;
  justify-content: center;
}

.popover-img {
  flex: 1;
  border-radius: 4px;
  border: 1px solid #f0f0f0;
}

/* 响应式适配 */
@media (max-width: 768px) {

  /* 调整断点 */
  .footer-content {
    flex-direction: column;
    gap: 40px;
  }

  .footer-left,
  .footer-right {
    max-width: 100%;
  }
}
</style>
<style>
/* 去掉 popover 的默认内边距，让图片展示更紧凑 */
.cert-popover {
  padding: 10px !important;
  min-width: auto !important;
}
</style>